/**
 * Loading required JS scripts and plugins such as jQuery and Bootstrap
 */

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('select2');
require('slick-carousel');
require('es6-promise').polyfill();
require( 'datatables.net-dt' );
window.ccValid = require("card-validator");

/**
 * Loading theme JS plugins
 */
// Require inputmask using jquery
// require("inputmask/dist/inputmask/jquery.inputmask");
// require("inputmask/dist/inputmask/inputmask.date.extensions");
// window.Inputmask = require('inputmask');